import { Spinner } from "@common";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";
import { useState } from "react";
import { ConsultantPresentationCountry } from "~/Server/graphql/types";

type Props = {
  consultantId: string;
};

export function ConsultantCv(props: Props) {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);

  const country = ConsultantPresentationCountry.Sweden;

  return (
    <>
      {loading && <Spinner />}
      <iframe
        onLoad={() => setLoading(false)}
        className={classes.iframe}
        src={`/consultant-cv/${props.consultantId}/pdf?country=${country}#toolbar=0`}
      />
    </>
  );
}

const useStyles = makeStyles((theme: ThemeType) => {
  return {
    iframe: {
      border: "none",
      height: "100vh"
    }
  };
});
